<script setup lang="ts"></script>

<template>
  <div id="noAuthPage">无权限</div>
</template>

<style scoped></style>
